import { IDateFormat } from "amnShared/interfaces/IDates";
import { ITimeFormat } from "amnShared/interfaces/ITimes";
import { NegativeDisplay, ThousandsSeperatorType } from "./INumbersHelper";

export interface INumbersCard {
  negativeSignDisplay: NegativeDisplay;
  dateFormat: IDateFormat;
  timeFormat: ITimeFormat
  isShowZeros: boolean;
  quantityDecimalPlace: number;
  valueDecimalPlace: number;
  exchangeRateDecimalPlace: number;
  isThousandsSeperator: boolean;
  thousandsSeperatorType: ThousandsSeperatorType;
}
export const EmptyNumbersCard: INumbersCard = {
  negativeSignDisplay: NegativeDisplay.NegativeSignDefaultColor,
  dateFormat: IDateFormat.D_M_YY,
  timeFormat: ITimeFormat.TIME_24HR,
  isShowZeros: true,
  quantityDecimalPlace: 2,
  valueDecimalPlace: 2,
  exchangeRateDecimalPlace: 2,
  isThousandsSeperator: true,
  thousandsSeperatorType: ThousandsSeperatorType.Comma,
};
